import {ProductInterface as CatalogProductInterface} from "../interfaces/catalog/ProductInterface";
import {useContext} from "react";
import {ReducerStateInterface} from "../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../GlobalReducer";
import {ProductInterface} from "../interfaces/product/ProductInterface";
import {BasketItemInterface} from "../interfaces/checkout/BasketItemInterface";

export default function useBasket(product: CatalogProductInterface | ProductInterface) {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const inBasket = () => {
        return state.basket?.map((item: BasketItemInterface) => item.product.id).includes(product?.id) || false;
    }

    const addToBasket = () => {
        dispatch({type: ReducerActionType.ADD_TO_BASKET, payload: product});
    }

    const removeFromBasket = () => {
        dispatch({type: ReducerActionType.REMOVE_FROM_BASKET, payload: product});
    }

    return {inBasket, addToBasket}
}